import { Config } from "@hey-api/client-fetch";
import { unreachable } from "./util/unreachable";

enum EnvironmentHostName {
  PRODUCTION = "portal.pleevi.ai",
  STAGING = "portal.stg.pleevi.ai",
  SANDBOX = "portal.sbx.pleevi.ai",
  LOCAL = "localhost",
}

enum BackendApiUrl {
  PRODUCTION = "https://api.pleevi.ai",
  STAGING = "https://api.stg.pleevi.ai",
  SANDBOX = "https://api.sbx.pleevi.ai",
  LOCAL = "http://localhost:8010",
}

const getBaseUrl = (location: Location) => {
  // Local development: portal.[env].pleevi.localhost -> api.[env].pleevi.localhost
  const hostname = location.hostname as EnvironmentHostName;
  if (hostname.endsWith("pleevi.localhost")) {
    return `http://${location.host.replace(/^portal\./, "api.")}`;
  }

  switch (hostname) {
    case EnvironmentHostName.PRODUCTION:
      return BackendApiUrl.PRODUCTION;

    case EnvironmentHostName.STAGING:
      return BackendApiUrl.STAGING;

    case EnvironmentHostName.SANDBOX:
      return BackendApiUrl.SANDBOX;

    case EnvironmentHostName.LOCAL:
      return BackendApiUrl.LOCAL;

    default:
      unreachable(hostname);
  }
};

export const createClientConfig = (config: Config) => ({
  ...config,
  baseUrl: getBaseUrl(window.location),
});
